import { path } from 'ramda'
import {
  BUSINESS_REGISTRATION_COMPLETED_EVENTS,
  ONBOARDING_USER_ROLE,
  DEFAULT_CURRENCY,
} from '@/lib/analytics/consts.ts'
import {
  APP_VERSION,
} from '@/lib/consts.ts'
import {
  getCategories,
  getDeviceType,
  getExternalId,
  getBusinessPrefixedPhone,
  simplifyCategory,
  getBusinessMarketingScore,
} from '@/lib/analytics/helpers.js'
import WebViewHandler from './web-view-handler.js'

export default class WebViewHandler1 extends WebViewHandler {
  eventOnboardingBusinessRegistrationCompletedHandler ({
    business,
    categories,
    primaryCategory,
  }) {
    business = business || {}

    const location = path(['location'], business) || {}
    const business_primary_category = simplifyCategory(primaryCategory)
    const simplifiedCategories = getCategories(categories)

    const payload = {
      properties: {
        business_name: business.name,
        business_primary_category,
        categories: simplifiedCategories,
        city: location.city,
        // postalCode is named with camel case convencion, because Segment recognizes this as special value
        postalCode: location.zipcode,
        af_currency: DEFAULT_CURRENCY,
        af_revenue: getBusinessMarketingScore(business_primary_category),
      },
    }

    const events = [
      {
        event_name: 'Business_Registration_Completed',
        ...payload,
      },
    ]

    const categoryEventName = BUSINESS_REGISTRATION_COMPLETED_EVENTS[business_primary_category]

    if (categoryEventName) {
      events.push({
        event_name: categoryEventName,
        ...payload,
      })
    }

    return events
  }

  eventOnboardingBusinessNameSetHandler ({ data }) {
    const business = path(['business'], data) || {}
    const business_name = path(['name'], business)

    return {
      event_name: 'Onboarding_Business_Name_Set',
      properties: {
        business_name,
      },
    }
  }

  eventOnboardingBusinessCreatedHandler ({ data, appType, country, device, routingConfig }) {
    const business = path(['business'], data) || {}
    const business_name = path(['name'], business)
    const device_type = getDeviceType(device)
    const business_id = getExternalId({ id: business.id, country, routingConfig })
    const business_phone = getBusinessPrefixedPhone({ business, country })

    return {
      event_name: 'Business_Registration_Started_Backend',
      properties: {
        app_version: APP_VERSION,
        business_id,
        business_name,
        business_phone,
        country,
        device,
        device_type,
        email: business.owner_email,
        user_role: ONBOARDING_USER_ROLE,
      },
    }
  }

  eventOnboardingPasswordSetHandler ({ business }) {
    const business_name = business?.name || null

    return {
      event_name: 'Onboarding_Password_Set',
      properties: {
        business_name,
      },
    }
  }
}
